module.exports = __webpack_public_path__ + "img/NFTPlayground.afdd880d.png";